/**
 * Get the BSCScan URL based on the chain ID
 * @param chainId - The chain ID (56 for mainnet, 97 for testnet)
 * @returns The BSCScan URL for the given network
 */
export function getBscScanUrl(chainId: number): string {
  switch (chainId) {
    case 56:
      return 'https://bscscan.com';
    case 97:
      return 'https://testnet.bscscan.com';
    default:
      return 'https://bscscan.com'; // Default to mainnet
  }
}

/**
 * Get the network name based on the chain ID
 * @param chainId - The chain ID (56 for mainnet, 97 for testnet)
 * @returns The network name
 */
export function getNetworkName(chainId: number): string {
  switch (chainId) {
    case 56:
      return 'BSC Mainnet';
    case 97:
      return 'BSC Testnet';
    default:
      return 'Unknown Network';
  }
}

/**
 * Check if the chain ID corresponds to BSC mainnet
 * @param chainId - The chain ID to check
 * @returns True if the chain ID is BSC mainnet (56)
 */
export function isBscMainnet(chainId: number): boolean {
  return chainId === 56;
}

/**
 * Check if the chain ID corresponds to BSC testnet
 * @param chainId - The chain ID to check
 * @returns True if the chain ID is BSC testnet (97)
 */
export function isBscTestnet(chainId: number): boolean {
  return chainId === 97;
}

/**
 * Check if the chain ID is a valid BSC network (mainnet or testnet)
 * @param chainId - The chain ID to check
 * @returns True if the chain ID is either BSC mainnet or testnet
 */
export function isValidBscNetwork(chainId: number): boolean {
  return isBscMainnet(chainId) || isBscTestnet(chainId);
}
